import { Card, CardContent, CardHeader, Grid, Stack, TextField } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { env } from '../../../api';
import { HashRateCalculatorSection } from './HashRateCalculatorSection';
import { MinerRevenueSection } from './MinerRevenueSection';
import { MinerFilterRevenueSection } from './MinerFilterRevenueSection';
import { HashUnit } from '../../../abelcommon';
import { GridSearchIcon } from '@mui/x-data-grid';
import { cardList } from './miner-card-data';
import { useHashrateRevenueCalculator } from '../../../abelcommon/hooks/useHashrateRevenueCalculator';
import { useTranslation } from 'react-i18next';
import { loadBalancerAPI } from '../../../api/load-balancer';

export const HashRateCalculatorPage = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = env.title + ` | ${t('hashRateCalculatorSectionPage.hashRateCalculator')}`;
  }, [t]);
  const [searchValue, setSearchValue] = useState('');
  const standardizedSearchValue = !searchValue ? undefined : searchValue.trim().toLocaleLowerCase();

  const [abelPrice, setAbelPrice] = useState(0.0);
  useEffect(() => {
    loadBalancerAPI.apiInstance
      .getAbelPrice()
      .then((price) => {
        setAbelPrice(price.data.price);
      })
      .catch((e) => {
        console.error('Failed to fetch Abel price:', e);
      });
    console.log(abelPrice);
  }, [abelPrice]);

  const [selectedId, setSelectedId] = useState<number | null>(null);
  const hashRateList = useMemo(() => cardList.map(({ hash_rate }) => hash_rate), []);
  const [cardWithHashrate, setCardWithHashrate] = useState([]);
  const { data: revenuesPerDay } = useHashrateRevenueCalculator(hashRateList, HashUnit.MH, abelPrice);

  useEffect(() => {
    if (!revenuesPerDay?.length) return;
    setCardWithHashrate(
      cardList.map((card, index) => ({
        ...card,
        revenue: revenuesPerDay[index].revenue,
        revenueUSD: revenuesPerDay[index].revenueUSD,
      }))
    );
  }, [revenuesPerDay]);

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <HashRateCalculatorSection abelPrice={abelPrice} />
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardHeader title={t('hashRateCalculatorSectionPage.minerEstimatedRevenuesPerCardType')} />
          <CardContent sx={{ overflow: 'auto' }}>
            <Stack sx={{ flexDirection: 'row', justifyContent: 'flex-end', mb: 1 }}>
              <TextField
                id="card-searchbox"
                label={
                  <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
                    <GridSearchIcon fontSize="small" />
                    <span>{t('hashRateCalculatorSectionPage.search')}...</span>
                  </Stack>
                }
                variant="outlined"
                size="small"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </Stack>

            {standardizedSearchValue ? (
              <MinerFilterRevenueSection
                cardWithHashrate={cardWithHashrate}
                onSelectId={setSelectedId}
                searchValue={standardizedSearchValue}
              />
            ) : (
              <MinerRevenueSection
                cardWithHashrate={cardWithHashrate}
                selectedId={selectedId}
                searchValue={standardizedSearchValue}
              />
            )}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
